import React from 'react';
import MarketPlaceTabHeader from '../../components/Common/MarketPlaceTabHeader/MarketPlaceTabHeader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Col, Empty, Row } from 'antd';
import ProjectCard from '../marketplacePage/ProjectCard';
import useFetchProjects from '../marketplacePage/useFetchProjects';
import './PartnerShipsProjects.css'; // Import your CSS file

const PartnerShipsSandboxProjects = () => {
    const { loading, projects, hasMore, searchFilter, fetchMoreData, querySearch } = useFetchProjects(null, null, null, null, null, true, null);

    // Group projects by section
    const groupedProjects = projects?.reduce((acc, project) => {
        const sectionName = project.sectionName || 'Other';
        const sectionOrder = project.sectionOrder || 999;

        if (!acc[sectionName]) {
            acc[sectionName] = {
                order: sectionOrder,
                projects: []
            };
        }
        acc[sectionName].projects.push(project);
        return acc;
    }, {});

    // Sort sections by order
    const sortedSections = Object.entries(groupedProjects || {})
        .sort(([, a], [, b]) => a.order - b.order);

    return (
        <>
            <MarketPlaceTabHeader
                showDealType={false}
                setVisible={false}
                searchFilter={searchFilter}
                querySearch={querySearch}
            />
            <InfiniteScroll
                dataLength={projects?.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={
                    <div style={{ textAlign: "center", fontSize: "2rem", padding: "1.5rem 0" }}>
                        Loading...
                    </div>
                }
                endMessage={<p style={{ textAlign: 'center' }}>No more projects</p>}
            >
                {projects?.length ? (
                    sortedSections.map(([sectionName, { projects: sectionProjects }]) => (
                        <div key={sectionName}>
                            <h2 className="section-title">{sectionName}</h2> {/* Apply the CSS class here */}
                            <Row gutter={[30, 30]}>
                                {sectionProjects.map((project) => (
                                    <Col md={8} sm={24} key={project._id} className="d-flex-card mb-1">
                                        <ProjectCard record={project} index={project?.projectId} />
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ))
                ) : (
                    <Empty style={{ margin: "30px auto" }} />
                )}
            </InfiniteScroll>
        </>
    );
}

export default PartnerShipsSandboxProjects;